// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sem-listing-items-container {
  border: 1px solid #ced4da;
  border-radius: 4px;
  background-color: #ffffff;
  max-height: 300px;
  overflow-y: auto;
  position: relative;
  min-width: 350px;
  width: 100%;
}

.sem-listing-item {
  padding: 8px 12px;
  border-bottom: 1px solid #f1f1f1;
  transition: background-color 0.15s ease;
}

.sem-listing-item:last-child {
  border-bottom: none;
}

.sem-listing-item:hover {
  background-color: #f8f9fa;
}

.sem-listing-item-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin: 0;
  font-size: 14px;
  font-weight: normal;
  width: 100%;
}

.sem-listing-checkbox {
  margin-right: 8px;
  margin-top: 0;
  margin-bottom: 0;
  cursor: pointer;
  width: 16px;
  height: 16px;
  accent-color: #007bff;
  pointer-events: auto; /* Ensure clicks work */
  position: relative;
  z-index: 1; /* Above any overlays */
}

.sem-listing-item-title {
  flex: 1;
  color: #333;
  line-height: 1.4;
  word-break: break-word;
}

.select-all-label {
  font-weight: 500;
}

.select-all-title {
  color: #007bff;
  font-weight: 500;
}

.sem-listing-separator {
  height: 1px;
  background-color: #dee2e6;
  margin: 0 12px;
}

.sem-listing-empty {
  padding: 20px 12px;
  text-align: center;
  color: #6c757d;
  font-style: italic;
  font-size: 14px;
}

.sem-listing-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 20px 12px;
  color: #666;
  font-size: 14px;
}

.sem-listing-error {
  padding: 12px;
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  color: #856404;
  font-size: 14px;
  margin-bottom: 8px;
}

/* Disabled state */
.disabled-field {
  opacity: 0.6;
  background-color: #f8f9fa !important;
}

.disabled-field .sem-listing-checkbox {
  cursor: not-allowed;
}

.disabled-field .sem-listing-item-label {
  cursor: not-allowed;
}

.disabled-field .sem-listing-item:hover {
  background-color: transparent;
}

/* Focus states */
.sem-listing-checkbox:focus {
  outline: 2px solid #007bff;
  outline-offset: 2px;
}

/* Custom scrollbar */
.sem-listing-items-container::-webkit-scrollbar {
  width: 6px;
}

.sem-listing-items-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.sem-listing-items-container::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.sem-listing-items-container::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Validation states */
.is-invalid {
  border-color: #dc3545;
}

.binding-prop-name {
  font-size: 10px;
  color: #6c757d;
  margin: 4px 0 0 0;
  font-family: monospace;
}

/* Inline search overlay - DISABLED for debugging */
.inline-search-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  cursor: pointer;
  display: none; /* TEMPORARILY DISABLED */
}`, "",{"version":3,"sources":["webpack://./src/app/components/controls/sem-listing-items/sem-listing-items.component.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,oBAAoB,EAAE,uBAAuB;EAC7C,kBAAkB;EAClB,UAAU,EAAE,uBAAuB;AACrC;;AAEA;EACE,OAAO;EACP,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA,mDAAmD;AACnD;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,eAAe;EACf,aAAa,EAAE,yBAAyB;AAC1C","sourcesContent":[".sem-listing-items-container {\r\n  border: 1px solid #ced4da;\r\n  border-radius: 4px;\r\n  background-color: #ffffff;\r\n  max-height: 300px;\r\n  overflow-y: auto;\r\n  position: relative;\r\n  min-width: 350px;\r\n  width: 100%;\r\n}\r\n\r\n.sem-listing-item {\r\n  padding: 8px 12px;\r\n  border-bottom: 1px solid #f1f1f1;\r\n  transition: background-color 0.15s ease;\r\n}\r\n\r\n.sem-listing-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.sem-listing-item:hover {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.sem-listing-item-label {\r\n  display: flex;\r\n  align-items: center;\r\n  cursor: pointer;\r\n  margin: 0;\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  width: 100%;\r\n}\r\n\r\n.sem-listing-checkbox {\r\n  margin-right: 8px;\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  cursor: pointer;\r\n  width: 16px;\r\n  height: 16px;\r\n  accent-color: #007bff;\r\n  pointer-events: auto; /* Ensure clicks work */\r\n  position: relative;\r\n  z-index: 1; /* Above any overlays */\r\n}\r\n\r\n.sem-listing-item-title {\r\n  flex: 1;\r\n  color: #333;\r\n  line-height: 1.4;\r\n  word-break: break-word;\r\n}\r\n\r\n.select-all-label {\r\n  font-weight: 500;\r\n}\r\n\r\n.select-all-title {\r\n  color: #007bff;\r\n  font-weight: 500;\r\n}\r\n\r\n.sem-listing-separator {\r\n  height: 1px;\r\n  background-color: #dee2e6;\r\n  margin: 0 12px;\r\n}\r\n\r\n.sem-listing-empty {\r\n  padding: 20px 12px;\r\n  text-align: center;\r\n  color: #6c757d;\r\n  font-style: italic;\r\n  font-size: 14px;\r\n}\r\n\r\n.sem-listing-loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 8px;\r\n  padding: 20px 12px;\r\n  color: #666;\r\n  font-size: 14px;\r\n}\r\n\r\n.sem-listing-error {\r\n  padding: 12px;\r\n  background-color: #fff3cd;\r\n  border: 1px solid #ffeaa7;\r\n  border-radius: 4px;\r\n  color: #856404;\r\n  font-size: 14px;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n/* Disabled state */\r\n.disabled-field {\r\n  opacity: 0.6;\r\n  background-color: #f8f9fa !important;\r\n}\r\n\r\n.disabled-field .sem-listing-checkbox {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.disabled-field .sem-listing-item-label {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.disabled-field .sem-listing-item:hover {\r\n  background-color: transparent;\r\n}\r\n\r\n/* Focus states */\r\n.sem-listing-checkbox:focus {\r\n  outline: 2px solid #007bff;\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* Custom scrollbar */\r\n.sem-listing-items-container::-webkit-scrollbar {\r\n  width: 6px;\r\n}\r\n\r\n.sem-listing-items-container::-webkit-scrollbar-track {\r\n  background: #f1f1f1;\r\n  border-radius: 3px;\r\n}\r\n\r\n.sem-listing-items-container::-webkit-scrollbar-thumb {\r\n  background: #c1c1c1;\r\n  border-radius: 3px;\r\n}\r\n\r\n.sem-listing-items-container::-webkit-scrollbar-thumb:hover {\r\n  background: #a8a8a8;\r\n}\r\n\r\n/* Validation states */\r\n.is-invalid {\r\n  border-color: #dc3545;\r\n}\r\n\r\n.binding-prop-name {\r\n  font-size: 10px;\r\n  color: #6c757d;\r\n  margin: 4px 0 0 0;\r\n  font-family: monospace;\r\n}\r\n\r\n/* Inline search overlay - DISABLED for debugging */\r\n.inline-search-wrapper {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 10;\r\n  cursor: pointer;\r\n  display: none; /* TEMPORARILY DISABLED */\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
